export default "<img\n  src=\"{{ partner.img }}\"\n  alt=\"{{ partner.alt }}\"\n  class=\"{{ partner.customize }}\"\n/>\n"